import React from 'react';
import { Redirect } from 'react-router-dom';
import { AuthenticatedWrapper } from '@blocs.auth';

const RootRedirect = () => (
  <AuthenticatedWrapper>
    <Redirect to="/login" />
  </AuthenticatedWrapper>
);

export default RootRedirect;
